<script>
import { mapGetters } from 'vuex'

import Translatable from '@src/mixins/translatable.js'
import OrderListDayItem from '@components/e-shop/order-list-day-item.vue'

export default {
  components: {
    OrderListDayItem
  },
  mixins: [
    Translatable
  ],
  props: {
    card: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('eShop', [
      'selectedType'
    ]),
    cardName() {
      const name = this.card.name.default
      .replace('Day', this.getTranslatedContent('ESHOP_product_name_DAY'))
      .replace('Prague', this.getTranslatedContent('ESHOP_product_name_PRAGUE'))

      return this.selectedType === 'coolpass' ?
      name.replace('Card', this.getTranslatedContent('ESHOP_product_name_COOLPASS')) :
      name.replace('Card', this.getTranslatedContent('ESHOP_product_name_CARD'))
    },
    cardTypes() {
      const adult = {
        cardId: this.card.id,
        data: this.card.adultCard,
        count: this.card.adultCardCount,
        sum: this.card.adultCardSum,
        type: 'adult'
      }
      const student = {
        cardId: this.card.id,
        data: this.card.studentCard,
        count: this.card.studentCardCount,
        sum: this.card.studentCardSum,
        type: 'child'
      }
      return [
        adult,
        student
      ]
    },
    isCount() {
      return this.card.adultCardCount || this.card.studentCardCount
    }
  },
}
</script>

<template>
  <div v-if="isCount" class="list-item-container">
    <h4 class="list-item-title">{{ cardName }}</h4>
    <OrderListDayItem v-for="(type, index) in cardTypes" :key="index" :card="type" />
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.list-item-container {
  margin-top: 43px;

  :nth-child(3) {
    border-top: none;
  }
}

.list-item-title {
  font-family: Open Sans Bold;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 23px;
  text-transform: uppercase;
  color: $black;

  margin: 0 0 24px 28px;
}

@media only screen and (max-width: $screen-width-xs) {
  .list-item-container {
    width: 100%;
  }

  .list-total{
    width: 100%;
    height: 70px;
    padding: 0;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .list-item-title {
    font-size: 16px;
    line-height: 21px;

    margin: 0 8px 25px 8px;
  }
}

</style>
